import { gql, useMutation } from '@apollo/client'

import {
  ArtistCreateDmRoomMutation,
  ArtistCreateDmRoomMutationVariables,
} from '@/clients/utoniq-core/schema'
import { useMessage, useRouter, useTranslation } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { t } = useTranslation('consoleDmRoomCreate')
  const { showMessage } = useMessage()
  const { router, routerPages } = useRouter()
  const { user } = useCurrentUser()
  const [createDmRoom] = useMutation<
    ArtistCreateDmRoomMutation,
    ArtistCreateDmRoomMutationVariables
  >(CREATE_DM_ROOM, {
    onCompleted() {
      showMessage(t('createSuccess'), 'success')
      router.goBack(routerPages.ConsoleDmRooms)
    },
  })
  return {
    state: {
      artistId: user?.uid ?? '',
    },
    actions: {
      async onSubmit(values) {
        await createDmRoom({
          variables: {
            inputs: values,
          },
        })
      },
    },
  }
})

const CREATE_DM_ROOM = gql`
  mutation ArtistCreateDmRoom($inputs: ArtistCreateDmRoomInput!) {
    artistCreateDmRoom(inputs: $inputs) {
      id
    }
  }
`
